let currentQuickView = {};

((holidayBundleQuickView, $) => {
  "use strict";

  let prevWindowWidth = $(window).width();
  let windowWidth = $(window).width();
  let filteredVariants = {};
  let quickViewSettings = {};

  const $dom = {};

  const cacheDom = () => {
    $dom.productImageWrapper = $(".js-image-wrapper");
    $dom.quickViewCTA = $(".js-quickview-cta");
  };

  const changeVariantTitle = () => {
    let optionValueList = [];
    $(".js-quickview-product-variant-option-selector").each(function() {
      optionValueList.push($(this).val());
    });
    let selectedVariantText = optionValueList.join(" | ");
    if (selectedVariantText.length > 0) {
      $(".js-quickview-product-title-variant").text(` | ${selectedVariantText}`);
    }
  };

  /* Borrowed Code from Product.js */
  const initSettings = () => {
    quickViewSettings = {};
    $(".js-quickview-product-variant-option-selector").each(function() {
      const optionName = $(this).data("name");
      const optionNum = $(this).data("option");
      const value = $(this).val();
      quickViewSettings[optionNum] = {
        name: optionName,
        value: value
      };
    });
  };

  const initDisabledSizes = () => {
    const keys = Object.keys(quickViewSettings);
    const nonSizeOptionKeys = keys.filter(
      key =>
        quickViewSettings[key] &&
        quickViewSettings[key].name.toString().toLowerCase() != "size"
    );
    const sizeOptionKeys = keys.filter(
      key =>
        quickViewSettings[key] &&
        quickViewSettings[key].name.toString().toLowerCase() == "size"
    );
    if (sizeOptionKeys.length > 0) {
      const sizeOption = sizeOptionKeys[0];
      const productVariants = currentQuickView.variants;
      const matchingVariants = productVariants.filter(variant => {
        for (let i = 0; i < nonSizeOptionKeys.length; i++) {
          if (
            variant[nonSizeOptionKeys[i]].toString().toLowerCase() !==
            quickViewSettings[nonSizeOptionKeys[i]].value
              .toString()
              .toLowerCase()
          ) {
            return false;
          }
        }
        return true;
      });

      $(".js-quickview-product-variant-size").each(function() {
        $(this).removeClass("is-disabled");
        let $that = $(this);
        const matchingSizeVariant = matchingVariants.filter(variant => {
          if (
            variant[sizeOption].toString().toLowerCase() ===
            $that
              .data("value")
              .toString()
              .toLowerCase()
          ) {
            return true;
          }
        });
        if (
          matchingSizeVariant.length < 1 ||
          (matchingSizeVariant.length > 0 && !matchingSizeVariant[0].available)
        ) {
          $(this).addClass("is-disabled");
          if ($(this).hasClass("is-active")) {
            $(this).removeClass("is-active");
          }
        } else if (
          $(this)
            .data("value")
            .toString()
            .toLowerCase() ===
          quickViewSettings[sizeOption].value.toString().toLowerCase()
        ) {
          $(this).addClass("is-active");
        }
      });

      $(".js-quickview-product-variant-size.is-disabled").each(function() {
        const $before = $(this).find(".product--variant-size-disabled-before");
        const $after = $(this).find(".product--variant-size-disabled-after");
        const opposite = $(this).outerHeight();
        const adjacent = $(this).outerWidth();
        const deg = Math.atan(opposite / adjacent) * (180 / Math.PI);
        $before.css({ transform: `skewY(${deg}deg)` });
        $after.css({ transform: `skewY(-${deg}deg)` });
      });
    }
  };

  const changeVariantOption = $that => {
    if (!($that.hasClass("is-active") || $that.hasClass("is-disabled"))) {
      const $displayList = $that.closest(".product--variant-display-list");
      const $selectList = $(
        `.js-quickview-product-variant-option-selector[data-name='${$displayList.data(
          "name"
        )}']`
      );
      $selectList.find("option").each(function() {
        if (
          $(this)
            .val()
            .toString()
            .toLowerCase() ===
          $that
            .data("value")
            .toString()
            .toLowerCase()
        ) {
          $selectList.val($(this).val()).change();
          return false;
        }
      });

      $displayList.find(".is-active").removeClass("is-active");
      $that.addClass("is-active");

      let attr = $that.attr("data-image-id");
      if (typeof attr !== typeof undefined && attr !== false) {
        let slideNum = 0;
        $(".product--images-featured-slide-image[data-image-id]").each(function() {
          if ($(this).attr("data-image-id") === attr) {
            slideNum = $(this)
              .parent()
              .attr("data-slick-index");
          }
        });
        slideNum = Number(slideNum);
        if (slideNum < 0) {
          slideNum = 0;
        }
        $(".js-quickview-product-featured-slider").slick("slickGoTo", slideNum);
      }
    }
  };

  const filterVariants = () => {
    let tempArray = currentQuickView.variants.slice();
    Object.keys(quickViewSettings).forEach(key => {
      tempArray = tempArray.filter(variant => {
        return variant[key] === quickViewSettings[key].value;
      });
    });
    filteredVariants = tempArray.slice();
    if (filteredVariants.length == 1) {
      const currentVariant = filteredVariants[0];
      if (currentVariant.available) {
        $(".js-quickview-atc-button")
          .prop("disabled", false)
          .removeClass("disabled");
        $(".js-quickview-atc-button-text").html("Add to Cart");
        $(".js-quickview-variant-selector")
          .val(currentVariant.id)
          .change();
      } else {
        $(".js-quickview-atc-button")
          .prop("disabled", true)
          .addClass("disabled");
        $(".js-quickview-atc-button-text").html("Sold Out");
      }
    }
  };

  const bindUIActions = () => {
    $(window).on("resize", function() {
      prevWindowWidth = windowWidth;
      windowWidth = $(window).width();
      initDisabledSizes();
      // Hide modal on mobile
      if (prevWindowWidth > 800 && windowWidth <= 800) {
        window.Modal.hide("quickview");
      }
    });

    // Show/Hide Quick View CTA
    $dom.productImageWrapper.on("mouseover", e => {
      const $target = $(e.currentTarget);
      $target.find(".js-quickview-cta").addClass("is-active");
    });

    $dom.productImageWrapper.on("mouseout", e => {
      const $target = $(e.currentTarget);
      $target.find(".js-quickview-cta").removeClass("is-active");
    });

    // Show Quick View Modal
    $dom.quickViewCTA.on("click", e => {
      e.preventDefault();
      e.stopPropagation();
      const $target = $(e.currentTarget),
        $modal = $(`[data-modal = "${$target.data("modal-open")}"]`),
        $modalContent = $modal.find(".js-modal-content");
      $modalContent.html($target.data("quickview-content"));
      currentQuickView = $target.data("js");

      const modalImage = $modalContent.find(".product--images-featured-slide-image").get(0);
      setTimeout(window.Sliders.initQuickviewFeaturedSlider, 0);

      // Init Quick View Product
      initSettings();
      initDisabledSizes();
      filterVariants();
      changeVariantTitle();
    });

    $(document).on("change", ".js-quickview-variant-selector", function(e) {
      e.preventDefault();
      changeVariantTitle();
    });

    $(document).on("click", ".js-quickview-variant-display-value", function() {
      changeVariantOption($(this));
    });

    $(document).on(
      "mouseenter",
      '[data-name="Color"] .js-quickview-variant-display-value',
      function() {
        $(this)
          .closest(".product--variant-display-option")
          .find(".js-quickview-current-variant-option")
          .text($(this).data("value"));
      }
    );

    $(document).on(
      "mouseout",
      '[data-name="Color"] .js-quickview-variant-display-value',
      function() {
        const optionNum = $(this)
          .closest(".product--variant-display-list")
          .data("option");
        $(this)
          .closest(".product--variant-display-option")
          .find(".js-quickview-current-variant-option")
          .text(quickViewSettings[optionNum].value);
      }
    );

    $(document).on("change", ".js-quickview-product-variant-option-selector", function() {
      const optionName = $(this).data("name");
      const optionNum = $(this).data("option");
      const value = $(this).val();
      quickViewSettings[optionNum].value = value;
      $(`.js-quickview-current-variant-option[data-name=${optionName}]`).text(
        value.charAt(0).toUpperCase() + value.slice(1)
      );
      initDisabledSizes();
      filterVariants();
    });

    // Switch content to size guide
    $(document).on("click", ".js-quickview-size-guide-link", e => {
      e.preventDefault();
      const $target = $(e.currentTarget),
        $quickViewContainer = $target.closest(".quickview-content"),
        $quickViewClose = $quickViewContainer.find(".quickview-close");
      $quickViewContainer.addClass("show-size");
      $quickViewClose.attr("disabled", true);
    });

    // Switch content back to Quick View Product
    $(document).on("click", '[data-modal-close="quickview"]', e => {
      e.preventDefault();
      const $target = $(e.currentTarget),
        $quickViewModal = $target.closest(".quickview-modal"),
        $quickViewContainer = $quickViewModal.find(".quickview-content"),
        $quickViewClose = $quickViewContainer.find(".quickview-close");
      $quickViewClose.attr("disabled", false);
      $quickViewContainer.removeClass("show-size");
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  holidayBundleQuickView.init = init;
})((window.holidayBundleQuickView = window.holidayBundleQuickView || {}), jQuery);
